<template>
  <component :is="renderAs" :bg-variant="variantRendered" :body-class="bodyClass" :title="renderAs === 'b-tab' ? title : ''">
    <div slot="header" v-if="showHeader && renderAs === 'b-card'">
      {{ title }}
      <div class="card-header-actions float-right">

        <slot name="actions"/>
        <b-link v-if="back" class="card-header-action" @click="goBack" :title="$t('base.back')"><i
          class="fas fa-arrow-circle-left"/></b-link>
        <b-link v-if="showReload" class="card-header-action" @click="delegate('onReload')" :title="$t('base.reload')"><i
          class="fas fa-redo"/>
        </b-link>
        <b-link v-if="showSave" class="card-header-action" @click="delegate('onSave')" :title="$t('base.save')"><i
          class="fas fa-save"/>
        </b-link>
        <b-link v-if="print" class="card-header-action" @click="doPrint" :title="$t('base.print')"><i
          class="fas fa-print"/></b-link>
        <b-link v-if="showConfig" class="card-header-action" @click="delegate('onConfig')" :title="$t('base.config')"><i
          class="fas fa-cog"/>
        </b-link>
        <b-link v-if="showAdd" class="card-header-action" @click="delegate('onAdd')" :title="$t('base.add')"><i
          class="fas fa-plus"/></b-link>

        <b-form-checkbox v-if="showActivation" v-model="active" @change="$emit('activeChange', $event)" style="display: inline" />

        <b-link class="card-header-action btn-minimize" v-b-toggle="collapseId">
          <i class="icon-arrow-up"/>
        </b-link>
      </div>
      <div class="float-right">
        <slot name="preActions"/>
      </div>
    </div>
    <div v-else>
      <div class="card-header-actions float-right" >
        <b-link v-if="back" class="card-header-action" @click="goBack" :title="$t('base.back')"><i
          class="fas fa-arrow-circle-left"/></b-link>
        <slot name="actions"/>
        <b-link v-if="showSave" class="card-header-action" @click="delegate('onSave')" :title="$t('base.save')"><i
          class="fas fa-save"/>
        </b-link>
        <b-link v-if="showAdd" class="card-header-action" @click="delegate('onAdd')" :title="$t('base.add')"><i
          class="fas fa-plus"/></b-link>
      </div>
    </div>

    <!--Content-->
    <b-collapse visible v-if="renderAs === 'b-card'" class="full-height">
      <div v-show="ready" class="h-100">
        <slot/>
      </div>

      <Loading v-if="!ready"></Loading>
    </b-collapse>
    <slot v-else/>
  </component>
</template>

<script>
import Loading from '../controls/Loading';

export default {
  name: "Widget",
  components: {
    Loading
  },
  props: {
    title: {
      default: '',
      type: String,
      required: false
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    bodyClass: {
      type: String,
      default: ''
    },
    showSave: false,
    back: false,
    disabled: false,
    showAdd: {
      type: Boolean,
      default: false
    },
    showActivation: {
      type: Boolean,
      default: false
    },
    defaultActiveValue: {
      type:Boolean,
      default: true
    },
    showReload: {
      type: Boolean,
      default: false
    },
    variant: {
      type: String,
      default: 'default'
    },
    showConfig: {
      type: Boolean,
      default: false
    },
    print: {
      type: Object,
      default: () => {
      }
    },
    ready: {
      type: Boolean,
      default: true
    },
    renderAs: {
      type: String,
      default: 'b-card'
    }
  },
  data() {
    return {
      collapseId: '',
      active: this.defaultActiveValue
    }
  },
  computed: {
    variantRendered() {
      return this.disabled || !this.active ? 'secondary' : this.variant;
    }
  },
  methods: {
    delegate(name) {
      this.$emit(name);
    },
    async doPrint() {
      const config = await this.$store.dispatch('config/fetch');
      let data = this.print.data();
      if (this.isPromise(data)) {
        data = data.then(result => {
          this.prepareForExport(result, config);
        });
      }
    },
    prepareForExport(data, config) {
      this.$store.dispatch('reporting/prepareForExport', {
        reportId: this.print.reportId,
        data
      }).then(requestId => {
        window.open(`${config.reportDesignerUrl}/designer/PrintPdf/${requestId}`);
      });

    },
    goBack() {
      if (this.back === true)
        history.go(-1);
      else {
        this.$router.push(this.back);
      }
    },
    getCollapseId() {
      let hash = 0;
      if (this.title.length === 0) return hash;

      for (let i = 0; i < this.title.length; i++) {
        let char = this.title.charCodeAt(i);
        hash = ((hash << 5) - hash) + char;
        hash = hash & hash;
      }
      return 'sty-collapseId-' + hash;
    },
    isPromise(promise) {
      return !!promise && typeof promise.then === 'function';
    }
  },
  beforeMount() {
    this.collapseId = this.getCollapseId();
  }
}
</script>

<style scoped>
.full-height {
  height: calc(100% - 50px);
  min-height: calc(100% - 50px);
  position: relative;
}
</style>
